const PROD_API = "https://api.vahak.in";
const DEV_API = "https://dev.vahak.in";

const VERCEL_USER_AGENT = "Vercel";

const ENV = process.env.REACT_APP_ENV || process.env.NEXT_PUBLIC_REACT_APP_ENV;
const IS_PROD_ENV = ENV === "production";

const API_URI = ENV === "production" ? PROD_API : DEV_API;

const API_V1 = API_URI + "/v1";
const API_V2 = API_URI + "/v2";
const NEXT_API = "/api";

// Transporters
const TRANSPORTER_SEARCH = API_V1 + "/c/ft?";
const TRANSPORTERS_BY_NAME = TRANSPORTER_SEARCH;
const TRANSPORTER_REVIEWS = API_V1 + "/c/rt/co";
const TRANSPORTER_FAQ = API_V1 + "/c/fq/id";

// Cities and places
const CITY_SEARCH = API_URI + "/s/city?q=";
const PLACES_API_SEARCH = API_V1 + "/s/p?q=";
const ROUTES_BY_COMPANY_ID = API_V1 + "/c/rt?";
const LAT_LONG_BY_PLACE_ID = API_V1 + "/s/details/place_id?";

// Loads
const POST_LOAD = API_V1 + "/ld/a?";
const ALL_LOADS = API_V1 + "/ld/all?";
const ALL_LOADS_V2 = API_V2 + "/ld/all?";
const LOAD_MARKET_V2 = API_V2 + "/mkt/web_ld?";
const LOAD_MARKET_V2_NEW = API_V2 + "/mkt/web_ld/new?";
const UPDATE_LOAD_DETAILS = API_V1 + "/ld/e";
const UPDATE_LOAD_ADDRESS = API_V1 + "/ld/adrs";

//TSO
const TAG_AGENT_CUSTOMER_LOADS_POSTED = API_V1 + "/adm/agent/ld?";
const TAG_AGENT_CUSTOMER_LORRIES_POSTED = API_V1 + "/adm/agent/lr?";
const LOADS_ENQUIRY_CARD = API_V1 + "/ld/filter/all";
const LORRY_ENQUIRY_CARD = API_V1 + "/lr/filter/all";
const ALL_CUSTOMERS_ENQUIRY_CARD = API_V1 + "/adm/agent/enquiry";

// Lorries
const ALL_LORRIES = API_V1 + "/lr/all?";
const ALL_LORRIES_V2 = API_V2 + "/lr/all?";
const EDIT_LORRY = API_V1 + "/lr/e";
const EDIT_LORRIES = API_V1 + "/lr/me";
const GET_LORRIES_BY_CATEGORY = API_V1 + "/s/lr?";
const POST_LORRY = API_V1 + "/lr/a?";
const REACTIVATE_LORRY = API_V1 + "/lr/reactivate?";
const LORRY_MARKET_V2 = API_V2 + "/mkt/web_lr?";
const UPDATE_LORRY_ROUTES = API_V1 + "/lr/ar/city";
const ADD_DRIVER_DETAILS = API_V1 + "/emp/a?";
const ATTACH_DRIVER_TO_LORRY = API_V1 + "/lr/add/driver?";
const REMOVE_DRIVER_FROM_LORRY = API_V1 + "/lr/remove/driver?";
const ENABLE_SIM_TRACK = API_V1 + "/lc/track/trip?";
const EDIT_SIM_TRACK = API_V1 + "/lc/track/edit-trip?";
const SEND_CONSENT_SIM_TRACK = API_V1 + "/lr/track/send-consent?";

// Lorry location
const GET_LORRY_LOCATION_HISTORY = API_V1 + "/lr/location/history";
const GET_LORRY_CURRENT_LOCATION_TRIPS_LIST = API_V1 + "/lc/trips/d";
const GET_REVERSE_GEO_POINT = API_V1 + "/lc/reverse/geopoint?";
const GET_LORRY_LOCATION_DETAILS = API_V1 + "/lr/loc/dtl?";

//Verify lorry from signzy
const VERIFY_LORRY_FROM_SIGNZY = API_V1 + "/lr/info/number?";

// Bidding
const SUBMIT_LOAD_BID = API_V1 + "/ld/bd?";
const SUBMIT_LORRY_BID = API_V1 + "/lr/bd?";
const BID_HISTORY = API_V1 + "/c/bh?";

// Register and Login
const OTP = API_V1 + "/u/o_w";
const OTP_VIA_WHATSAPP = API_URI + "/rotpws?number=";
const LOGIN_VIA_OTP = API_V1 + "/u/vo_w";
const VERIFY_OTP = API_V1 + "/u/just/vo?";
const VALIDATE_TOKEN = API_V1 + "/u/v";
const LOGOUT = API_V1 + "/u/lg";
const REGISTER_COMPANY_DETAILS = API_V1 + "/c/r";

// Trips
const GET_TRIP_DOCS = API_V1 + "/lr/s_docs";
const POST_TRIP_DOCS = API_V1 + "/lr/up";

// User Report
const GET_USER_REPORTS = API_V1 + "/c/report/reasons?";

// Call back request
const CALL_BACK_REQUEST = API_V1 + "/m/hs";

// KYC verification
const DIGILOCKER_AADHAAR_NUMBER_VERIFICATION = API_V1 + "/u/durl?";

// KYC verification - SurePass
const VERIFY_AADHAAR_NUMBER_AND_GET_OTP = API_V1 + "/u/ao?";
const VERIFY_AADHAAR_OTP = API_V1 + "/u/av?";
const VERIFY_PAN = API_V1 + "/c/pan";
const VERIFY_GST_NUMBER = API_V1 + "/c/go?";
const VERIFY_GST_OTP = API_V1 + "/c/gv?";

const GET_DOCUMENTS = API_V1 + "/misc/g_doc";
const UPLOAD_DOCUMENTS = API_V1 + "/misc/u_doc";
const DELETE_DOCUMENT = API_V1 + "/misc/d_doc";

// User profile and Company
const USER_PROFILE_DETAILS = API_V1 + "/c/d?";
const USER_CASHBACK_DETAILS = API_V1 + "/c/cb_d?";
const UPDATE_COMPANY_DETAILS = API_V1 + "/c/u?";
const UPDATE_COMPANY_META_DETAILS = API_V1 + "/c/u/c_m";
const USER_PROFILE_ADD_FAQ = API_V1 + "/c/fq?";
const USER_PROFILE_EDIT_FAQ = API_V1 + "/c/ufq?";
// const ALL_OFFICE_ADDRESS = API_V1 + "/adr/r?";
const ADD_EDIT_OFFICE_ADDRESS = API_V1 + "/adr/cu?";
const DELETE_OFFICE_ADDRESS = API_V1 + "/adr/d?";
const UPLOAD_IMAGE = API_V1 + "/c/up?";
const COMPANY_REVIEW_DETAILS = API_V1 + "/c/rv?";
const COMPANY_ROUTE_DETAILS = API_V1 + "/c/rt?";
const COMPANY_ROUTE_DETAILS_V2 = API_V2 + "/c/rt?";
const GET_NEAR_BY_CITIES = API_V1 + "/lc/nearby/cities?";
const UPDATE_COMPANY_ROUTES = API_V1 + "/c/ar?";
const COMPANIES_INFO = API_V1 + "/c/info?";
const ADD_PROFILE_DISPOSITION = API_V1 + "/c/dis/add";
const GET_PROFILE_DISPOSITION = API_V1 + "/c/dis?";

//Load Lorries posting and bidding counts
const GET_USER_LOAD_LORRY_POSTINGS_BIDS_COUNTS = API_V1 + "/ldlr/count";

// User Lorries
const USER_LORRY_INFO_BY_ID = API_V1 + "/lr/d?";
const USER_LORRY_RECEIVED_BIDS_BY_ID = API_V1 + "/lr/bds?";
const USER_LORRY_SENT_BIDS_BY_ID = API_V1 + "/lr/sbds?";
const USER_LORRY_ROUTES_BY_ID = API_V1 + "/lr/rts?";
const USER_DEACTIVATE_LORRY = API_V1 + "/lr/tg?";
const USER_DELETE_LORRY = API_V1 + "/lr/delete?";
const USER_LIVE_LOAD_BY_LORRY_ID = API_V1 + "/lr/ll?";
const USER_LIVE_LOAD_BY_LORRY_ID_V2 = API_V2 + "/lr/ll?";
const USER_LORRY_INCENTIVE_INFO = API_V1 + "/lr/incentive/trips?";

// User Load
const USER_LOAD_INFO_BY_ID = API_V1 + "/ld/d?";
const USER_LOAD_RECEIVED_BIDS_BY_ID = API_V1 + "/ld/bds?";
const USER_LOAD_SENT_BIDS_BY_ID = API_V1 + "/ld/sbds?";
const USER_LIVE_LORRY_BY_LOAD_ID = API_V1 + "/ld/ll?";
const USER_LIVE_LORRY_BY_LOAD_ID_V2 = API_V2 + "/ld/ll?";
const USER_LOAD_STOPS = API_V1 + "/ld/stops?";
const GET_PAST_TRANSACTORS = API_V2 + "/lr/p/txns?";
const PAST_DEPOSITORS = API_V2 + "/lr/past_depositors?";

// Load Transaction api
const LOAD_TRANSACTION_LIST = API_V1 + "/tx/ldd?";
const LOAD_TRANSACTION_ACCEPT_OR_REJECT_BID = API_V1 + "/ld/bd/upd?";

// Lorry Transaction api
const LORRY_TRANSACTION_LIST = API_V1 + "/tx/lrd?";
const LORRY_TRANSACTION_ACCEPT_OR_REJECT_BID = API_V1 + "/lr/bd/upd?";

// Transporters List
const TRANSPORTERS_BY_LOAD = API_V1 + "/ld/tr";
const TRANSPORTERS_BY_LORRY = API_V1 + "/lr/tr";
const CONNECT_REQUEST_API = API_V1 + "/nw/a";
const REMOVE_REQUEST_API = API_V1 + "/nw/u";

// Internal use
const BLOCK_USERS = API_V1 + "/u/block";
const UNBLOCK_USERS = API_V1 + "/u/unblock";
const SEND_WHATSAPP_MESSAGE = API_URI + "/cwm";

// Admin Console
const LOGIN_ADMIN_CONSOLE = API_V1 + "/u/t";
const RESET_PASSWORD_ADMIN_CONSOLE = API_V1 + "/u/r";
const GET_OTP_FOR_RESETPASSWORD = API_V1 + "/u/o";
const CUSTOMER_PROFILE_DETIALS_BY_PHONE = API_V1 + "/c/phnos?";
const GET_USER_ROLES = API_V1 + "/u/roles?";
const ADMIN_VERIFY_LOAD = API_V1 + "/ld/vr?";
const EDIT_LOAD = API_V1 + "/ld/mel";

//C2C - call api
const C2C_CALLBACK = API_V1 + "/c/c2c";

// Deactivate Load Lorry api
const DEACTIVATE_LOAD_BY_ID = API_V1 + "/ld/disable?";
const DEACTIVATE_LORRY_BY_ID = API_V1 + "/lr/deactivate?";

// Comments API's
const ADD_LORRY_COMMENT = API_V1 + "/lr/ac";
const ADD_LOAD_COMMENT = API_V1 + "/ld/ac";
const GET_LORRY_COMMENT = API_V1 + "/lr/gc";
const GET_LOAD_COMMENT = API_V1 + "/ld/gc";

//Premium Load
const PREMIUM_BULK_LOAD_EDIT = API_V1 + "/ld/mel";
const PREMIUM_BULK_LOAD_PUBLISH = API_V1 + "/ld/ma";
const PREMIUM_BID_ACCEPT_OR_REJECT = API_V1 + "/ld/bd/mupd";
const UPDATE_BID_BY_ID = API_V1 + "/ld/bd/mupd";
const PREMIUM_BULK_LOAD_DELETE = API_V1 + "/ld/mdlt";
const PREMIUM_CLIENT_LIST = API_V1 + "/p/list?kam_uid=";

//Trip
const PREMIUM_TRIP_GET_TRACKING_LOCATION = API_V1 + "/lr/loc?";
const PREMIUM_TRIP_GET_SIM_TRACK = API_V1 + "/lr/simtrack?";

//Payment and Cashback
const PREMIUM_REQUEST_PAYMENT_LINK = API_V1 + "/rzp/py/link";
const GET_PAYMENT_LINK_DETAILS = API_V1 + "/py/link/details?";
const PREMIUM_RELEASE_PAYMENT = API_V1 + "/py/release";
const PAYMENTS_INFORMATION = API_V1 + "/py/d";
const PREMIUM_PAYMENT_STATUS = API_V1 + "/rzp/py/link/upd";
const GET_TRANSACTION_DETAILS = API_V1 + "/py/txns";
const CHECK_ELIGIBILITY = API_V1 + "/py/check-eligibility?";
const ADD_CASHBACK_COIN = API_V1 + "/py/ad/cashback/add?";

// Bulk Loads
const POST_BULK_LOAD = API_V1 + "/ld/bulk";
const BULK_LOAD_POSTING_STATUS = API_V1 + "/bulk/records?";
const ALL_BULK_LOADS = API_V1 + "/ld/bulkall";

// My Bids
const LOAD_MY_BIDS = API_V1 + "/ld/mybids?";
const LORRY_MY_BIDS = API_V1 + "/lr/mybids?";
const LOAD_LORRY_GET_BID_INFO = API_V1 + "/ldlr/bidinfo?";

// Image Upload
const MISC_UPLOAD_IMAGE = API_URI + "/misc/upload_image";

// Attach Lorry to Bid
const ATTACH_LORRY_TO_BID = API_V1 + "/ld/mal";

//Get company status for posting and bidding Limit
const GET_COMPANY_POSTING_AND_BIDDING_LIMIT = API_V1 + "/c/status";
const GET_USER_ACTION_VALIDATION = API_V2 + "/c/status?";

// KAM Details By Company ID
const GET_KAM_DETAILS_BY_COMPANY_ID = API_V1 + "/p/kam/details?";

// Ticket System
const CREATE_TICKET = API_V1 + "/tkt/ct";
const GET_TICKETS = API_V1 + "/tkt/all";
const GET_LOAD_TICKETS = API_V1 + "/tkt/load";
const UPDATE_TICKET_STATUS = API_V1 + "/tkt/art";
const GET_TICKET_BY_ID = API_V1 + "/tkt/id";
const CALL_ME_BACK_REQUEST = API_V1 + "/tkt/cmb";
const TICKET_HELP_REQUEST = API_V1 + "/tkt/hr";
const ASSIGN_TICKET = API_V1 + "/tkt/assign/me";
const RE_ASSIGN_ALL_TICKET = API_V1 + "/tkt/auto_assign_ticket";
const LOAD_REASSIGN = API_V1 + "/tkt/load/e";
const LOAD_REASSIGN_V2 = API_V1 + "/tkt/assign_agent";

// Admin System journey
const TAG_USER = API_V1 + "/adm/ctag";
const UNTAG_USER = API_V1 + "/adm/utag";
const GET_TAGGED_USERS = API_V1 + "/adm/tagcom?";

// Admin Role Management
const GET_CS_USER_ROLES = API_V1 + "/adm/listroles?"; // fetch all roles name available
const GET_CS_USER_OPERATIONS = API_V1 + "/adm/operation?"; // fetch all operation name available
const GET_CS_USER_ROLE_OPERATIONS = API_V1 + "/adm/role/op?";
const UPDATE_CS_USER_ROLE_OPERATIONS = API_V1 + "/adm/ed/roleop?";

// Admin User Management
const GET_CS_USERS = API_V1 + "/adm/urole?"; // list cs user
const GET_CS_USER_DETAILS = API_V1 + "/adm/urole/id?";

const ADD_CS_USER = API_V1 + "/adm/reg/emp?";
const UPDATE_CS_USER = API_V1 + "/adm/ed/emp?";
const DELETE_CS_USER = API_V1 + "/adm/user/role?";

// VAS
const GET_VAS_PLANS = API_V1 + "/c/pl?";
const GET_VAS_PLAN_BY_ID = API_V1 + "/c/pid?";
const SEND_VAS_LINK = API_V1 + "/py/rzp/subscriptionpayment?";
const VAS_MEMBERSHIP_RECENT = API_V1 + "/c/msp/rplan?";
const VAS_MEMBERSHIP_HISTORY = API_V1 + "/c/msp/history?";
const VAS_ADD_GPS = API_V1 + "/c/vas/gps/add?";
const VAS_GPS_HISTORY = API_V1 + "/c/vas/gps/history?";
const VAS_GPS_STATE = API_V1 + "/c/gps/states?";
const VAS_CARGO_HISTORY = API_V1 + "/ins/history?";
const VAS_CARGO_HISTORY_ADMIN = API_V1 + "/ins/history/ad?";
const VAS_CARGO_PREMIUM = API_V1 + "/ins/gpp";
const VAS_ADD_CARGO = API_V1 + "/ins/gins";
const VAS_CARGO_MATERIAL_LIST = API_V1 + "/ti/mt";
const CREATE_VAS_TICKET = API_V1 + "/tkt/vas";

//Payment Link
const RAZORPAY_PAYMENT_LINK = API_V1 + "/py/cr-py-ord?";

// Admin Remarks Update
const UPDATE_REMARKS = API_V1 + "/ldlr/acd?";

// User Bank
const GET_BANK_DETAILS = API_V1 + "/py/rzp/vr/bnk?";
const ADD_BANK_DETAILS = API_V1 + "/py/rzp/bnk/add?";
const ADD_VPA_DETAILS = API_V1 + "/py/rzp/upi/add?";
const DEL_BANK_DETAILS = API_V1 + "/py/rzp/bnk/del";

// Bids Payment Info
const BIDS_PAYMENT_INFO = API_V1 + "/py/ad/bids?";

// Invoice Generate Bill of supply
const INVOICE_GENERATE_BILL = API_V1 + "/inv/genbill";

const POPULAR_LANE_FOR_CITY = API_V1 + "/lc/city/info?";
const POPULAR_CITIES = API_V1 + "/lc/top/cities?";
const POPULAR_LANE_FOR_COUNTRY = API_V1 + "/lc/country/info?";
const PRICE_RECOMMENDATION = API_V1 + "/ld/pr?";

const TRUE_CALLER_REGISTRATION = API_V1 + "/u/web/trc";
//Firebase
const GET_SHORT_LINK = "https://firebasedynamiclinks.googleapis.com/v1/shortLinks?";

// Bulk Tag
const BULK_TAG = API_V1 + "/adm/ctag/bulk?";
const BULK_UNTAG = API_V1 + "/adm/utag/bulk?";

//Report system
const PAYMENT_REPORT = API_V1 + "/rs/report";
const REPORT_UPDATE_DISPOSITION = API_V1 + "/rs/report/disp";

// Update Load Expected Amount
const UPDATE_EXPECTED_AMOUNT = API_V1 + "/ld/uat";
const UPDATE_PREFERRED_AMOUNT = API_V1 + "/ld/e/prf/amt";
const ASSURED_LOAD_CANCEL = API_V1 + "/ld/tng/cl";

const GET_BOOKING_AMOUNT = API_V1 + "/py/booking-amount?";
const CALCULATE_PAYMENT_BREAKUP = API_V1 + "/py/calculate-payment-breakup?";
const GET_CASHBACK_USAGE_LIMIT = API_V1 + "/py/lmt/cshbk?";
const GET_PAYMENT_LEDGER = API_V1 + "/py/ledger?";

// Notifications
const ADMIN_NOTIFICATION = API_V1 + "/nf/notify";
const ADMIN_SEND_JOURNEY_FEEDBACK = API_V1 + "/lr/feedback/send_link";

// Load Ticket System
const GET_DISPOSITION_HISTORY = API_V1 + "/ldlr/disposition/history?";
const UPDATE_BID_TIME_INFO = API_V1 + "/ld/bd/inform/time";

// Call
const CALL_INITIATE = API_V1 + "/cl/a";
const CONFERENCE_INITIATE = API_V1 + "/c/conference/create";
const CONFERENCE_KICKOUT = API_V1 + "/c/conference/kickout";
const CONFERENCE_END = API_V1 + "/c/conference/end";

// TSO Lead Dashboard
const TSO_VISIT_CHECK_IN_AND_OUT = API_V1 + "/c/tso/s_a";
const TSO_SESSIONS = API_V1 + "/c/tso/history";
const CALCULATE_ROUTES_DISTANCE = NEXT_API + "/cd";

// CS Attendance
const UPDATE_CS_ATTENDANCE = API_V1 + "/emp/log_attendance";
const GET_CS_ATTENDANCE = API_V1 + "/emp/h_attendance";
const GET_CS_TEAM_ATTENDANCE = API_V1 + "/emp/team_attendance";

// Bid MISC
const UPDATE_BID_META_DETAILS = API_V1 + "/ld/u/bid_meta";
const GET_AGGREGATE_BID_BY_COMPANYID = API_V1 + "/ld/mybids_aggregated";

// agent status
const GET_AGENT_TEAM_STATUS = API_V2 + "/ld/agent_team_wise_loads";
const GET_EVENT_HISTORY = API_V1 + "/adm/events";
//
const UPDATE_LOAD_JOURNEY_INFO = API_V1 + "/ld/stage/event/a";
const GET_LOAD_JOURNEY_INFO = API_V1 + "/ld/stage/events?";
const UPDATE_ADMIN_NOTIFICATION_STATUS = API_V1 + "/tkt/ntf/seen?";
const GET_PAST_JOURNEY_COUNT = API_V1 + "/ld/trip/counts?";
const GET_LOAD_TRIP_SUMMARY = API_V1 + "/ld/trips/summary";

const API = {
    TRANSPORTER_SEARCH,
    TRANSPORTERS_BY_NAME,
    TRANSPORTER_REVIEWS,
    TRANSPORTER_FAQ,
    CITY_SEARCH,
    PLACES_API_SEARCH,
    GET_TRIP_DOCS,
    POST_TRIP_DOCS,
    OTP,
    ALL_LOADS,
    ALL_LOADS_V2,
    ALL_LORRIES,
    ALL_LORRIES_V2,
    EDIT_LORRY,
    EDIT_LORRIES,
    SUBMIT_LOAD_BID,
    SUBMIT_LORRY_BID,
    POST_LOAD,
    POST_LORRY,
    REACTIVATE_LORRY,
    ROUTES_BY_COMPANY_ID,
    LOGIN_VIA_OTP,
    VERIFY_OTP,
    OTP_VIA_WHATSAPP,
    VALIDATE_TOKEN,
    BID_HISTORY,
    REGISTER_COMPANY_DETAILS,
    CALL_BACK_REQUEST,
    GET_LORRIES_BY_CATEGORY,
    USER_PROFILE_DETAILS,
    USER_CASHBACK_DETAILS,
    USER_PROFILE_ADD_FAQ,
    USER_PROFILE_EDIT_FAQ,
    // ALL_OFFICE_ADDRESS,
    ADD_EDIT_OFFICE_ADDRESS,
    DELETE_OFFICE_ADDRESS,
    UPLOAD_IMAGE,
    COMPANY_REVIEW_DETAILS,
    COMPANY_ROUTE_DETAILS,
    COMPANY_ROUTE_DETAILS_V2,
    GET_NEAR_BY_CITIES,
    UPDATE_COMPANY_ROUTES,
    USER_LORRY_INFO_BY_ID,
    USER_LORRY_ROUTES_BY_ID,
    USER_DEACTIVATE_LORRY,
    USER_DELETE_LORRY,
    LOAD_TRANSACTION_LIST,
    LOAD_TRANSACTION_ACCEPT_OR_REJECT_BID,
    ADMIN_VERIFY_LOAD,
    LORRY_TRANSACTION_LIST,
    LORRY_TRANSACTION_ACCEPT_OR_REJECT_BID,
    UPDATE_COMPANY_DETAILS,
    UPDATE_COMPANY_META_DETAILS,
    USER_LOAD_INFO_BY_ID,
    USER_LOAD_RECEIVED_BIDS_BY_ID,
    USER_LOAD_SENT_BIDS_BY_ID,
    USER_LORRY_RECEIVED_BIDS_BY_ID,
    USER_LORRY_SENT_BIDS_BY_ID,
    USER_LIVE_LOAD_BY_LORRY_ID,
    USER_LIVE_LOAD_BY_LORRY_ID_V2,
    USER_LIVE_LORRY_BY_LOAD_ID,
    USER_LIVE_LORRY_BY_LOAD_ID_V2,
    USER_LOAD_STOPS,
    GET_PAST_TRANSACTORS,
    PAST_DEPOSITORS,
    TRANSPORTERS_BY_LOAD,
    TRANSPORTERS_BY_LORRY,
    CONNECT_REQUEST_API,
    REMOVE_REQUEST_API,
    BLOCK_USERS,
    UNBLOCK_USERS,
    SEND_WHATSAPP_MESSAGE,
    LOGIN_ADMIN_CONSOLE,
    RESET_PASSWORD_ADMIN_CONSOLE,
    GET_OTP_FOR_RESETPASSWORD,
    CUSTOMER_PROFILE_DETIALS_BY_PHONE,
    DIGILOCKER_AADHAAR_NUMBER_VERIFICATION,
    GET_USER_ROLES,
    C2C_CALLBACK,
    DEACTIVATE_LOAD_BY_ID,
    DEACTIVATE_LORRY_BY_ID,
    LOGOUT,
    ADD_LORRY_COMMENT,
    ADD_LOAD_COMMENT,
    GET_LORRY_COMMENT,
    GET_LOAD_COMMENT,
    PREMIUM_BULK_LOAD_EDIT,
    PREMIUM_BULK_LOAD_PUBLISH,
    PREMIUM_BID_ACCEPT_OR_REJECT,
    PREMIUM_BULK_LOAD_DELETE,
    PREMIUM_TRIP_GET_TRACKING_LOCATION,
    PREMIUM_TRIP_GET_SIM_TRACK,
    PREMIUM_CLIENT_LIST,
    PREMIUM_REQUEST_PAYMENT_LINK,
    GET_PAYMENT_LINK_DETAILS,
    PREMIUM_RELEASE_PAYMENT,
    PAYMENTS_INFORMATION,
    PREMIUM_PAYMENT_STATUS,
    POST_BULK_LOAD,
    BULK_LOAD_POSTING_STATUS,
    ALL_BULK_LOADS,
    EDIT_LOAD,
    ATTACH_LORRY_TO_BID,
    GET_TRANSACTION_DETAILS,
    LOAD_MY_BIDS,
    LORRY_MY_BIDS,
    LOAD_LORRY_GET_BID_INFO,
    VERCEL_USER_AGENT,
    MISC_UPLOAD_IMAGE,
    GET_USER_REPORTS,
    GET_COMPANY_POSTING_AND_BIDDING_LIMIT,
    GET_KAM_DETAILS_BY_COMPANY_ID,
    CREATE_TICKET,
    GET_TICKETS,
    GET_LOAD_TICKETS,
    UPDATE_TICKET_STATUS,
    GET_TICKET_BY_ID,
    CALL_ME_BACK_REQUEST,
    TICKET_HELP_REQUEST,
    ASSIGN_TICKET,
    RE_ASSIGN_ALL_TICKET,
    VERIFY_AADHAAR_NUMBER_AND_GET_OTP,
    VERIFY_AADHAAR_OTP,
    VERIFY_PAN,
    VERIFY_GST_NUMBER,
    VERIFY_GST_OTP,
    GET_DOCUMENTS,
    UPLOAD_DOCUMENTS,
    TAG_USER,
    UNTAG_USER,
    GET_TAGGED_USERS,
    GET_USER_ACTION_VALIDATION,
    GET_USER_LOAD_LORRY_POSTINGS_BIDS_COUNTS,
    GET_CS_USER_ROLES,
    GET_CS_USER_OPERATIONS,
    GET_CS_USERS,
    GET_CS_USER_DETAILS,
    GET_CS_USER_ROLE_OPERATIONS,
    UPDATE_CS_USER_ROLE_OPERATIONS,
    UPDATE_CS_USER,
    DELETE_CS_USER,
    ADD_CS_USER,
    GET_VAS_PLANS,
    GET_VAS_PLAN_BY_ID,
    SEND_VAS_LINK,
    RAZORPAY_PAYMENT_LINK,
    VAS_MEMBERSHIP_RECENT,
    VAS_MEMBERSHIP_HISTORY,
    VAS_ADD_GPS,
    VAS_GPS_HISTORY,
    VAS_GPS_STATE,
    VAS_CARGO_HISTORY,
    VAS_CARGO_HISTORY_ADMIN,
    VAS_CARGO_PREMIUM,
    VAS_ADD_CARGO,
    VAS_CARGO_MATERIAL_LIST,
    UPDATE_REMARKS,
    VERIFY_LORRY_FROM_SIGNZY,
    LOADS_ENQUIRY_CARD,
    LORRY_ENQUIRY_CARD,
    TAG_AGENT_CUSTOMER_LOADS_POSTED,
    TAG_AGENT_CUSTOMER_LORRIES_POSTED,
    ALL_CUSTOMERS_ENQUIRY_CARD,
    GET_BANK_DETAILS,
    ADD_BANK_DETAILS,
    ADD_VPA_DETAILS,
    DEL_BANK_DETAILS,
    BIDS_PAYMENT_INFO,
    INVOICE_GENERATE_BILL,
    LOAD_MARKET_V2,
    LOAD_MARKET_V2_NEW,
    COMPANIES_INFO,
    LAT_LONG_BY_PLACE_ID,
    LORRY_MARKET_V2,
    POPULAR_LANE_FOR_CITY,
    POPULAR_CITIES,
    POPULAR_LANE_FOR_COUNTRY,
    PRICE_RECOMMENDATION,
    GET_SHORT_LINK,
    PAYMENT_REPORT,
    LOAD_REASSIGN,
    LOAD_REASSIGN_V2,
    BULK_TAG,
    BULK_UNTAG,
    CREATE_VAS_TICKET,
    UPDATE_EXPECTED_AMOUNT,
    UPDATE_PREFERRED_AMOUNT,
    GET_BOOKING_AMOUNT,
    CALCULATE_PAYMENT_BREAKUP,
    GET_CASHBACK_USAGE_LIMIT,
    GET_PAYMENT_LEDGER,
    TRUE_CALLER_REGISTRATION,
    CREATE_VAS_TICKET,
    REPORT_UPDATE_DISPOSITION,
    ADD_PROFILE_DISPOSITION,
    GET_PROFILE_DISPOSITION,
    ADMIN_NOTIFICATION,
    ADMIN_SEND_JOURNEY_FEEDBACK,
    GET_DISPOSITION_HISTORY,
    UPDATE_BID_TIME_INFO,
    GET_LORRY_LOCATION_HISTORY,
    GET_LORRY_CURRENT_LOCATION_TRIPS_LIST,
    GET_REVERSE_GEO_POINT,
    GET_LORRY_LOCATION_DETAILS,
    UPDATE_LORRY_ROUTES,
    DELETE_DOCUMENT,
    ADD_DRIVER_DETAILS,
    ATTACH_DRIVER_TO_LORRY,
    REMOVE_DRIVER_FROM_LORRY,
    ENABLE_SIM_TRACK,
    EDIT_SIM_TRACK,
    SEND_CONSENT_SIM_TRACK,
    ASSURED_LOAD_CANCEL,
    UPDATE_BID_BY_ID,
    UPDATE_LOAD_DETAILS,
    UPDATE_LOAD_ADDRESS,
    USER_LORRY_INCENTIVE_INFO,
    CALL_INITIATE,
    CONFERENCE_INITIATE,
    CONFERENCE_KICKOUT,
    CONFERENCE_END,
    TSO_VISIT_CHECK_IN_AND_OUT,
    TSO_SESSIONS,
    UPDATE_CS_ATTENDANCE,
    GET_CS_ATTENDANCE,
    GET_CS_TEAM_ATTENDANCE,
    UPDATE_BID_META_DETAILS,
    CHECK_ELIGIBILITY,
    GET_AGGREGATE_BID_BY_COMPANYID,
    ADD_CASHBACK_COIN,
    GET_AGENT_TEAM_STATUS,
    GET_EVENT_HISTORY,
    UPDATE_LOAD_JOURNEY_INFO,
    GET_LOAD_JOURNEY_INFO,
    GET_LOAD_TRIP_SUMMARY,
    CALCULATE_ROUTES_DISTANCE,
    UPDATE_ADMIN_NOTIFICATION_STATUS,
    GET_PAST_JOURNEY_COUNT
};

export { IS_PROD_ENV, API as default };
//# sourceMappingURL=const.js.map
